import { connectWithStore } from '../../../jsCore/utils/connectWithStore'
import { getLogoImageSrc } from '../../../jsCore/store/logo/logo.selectors'
import { LogoContainer } from './logo.container'

const mapStateTpProps = (state, props) => ({
  imageSrc: getLogoImageSrc(state) ? getLogoImageSrc(state) : props.imageSrc,
})

export const LogoContainerWithStore = connectWithStore(LogoContainer, mapStateTpProps)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/logo/logoWithStore.container.js